import type { Reroute } from "@sveltejs/kit/hooks";
import { getDomainEntry } from "#lib/constants/domains.js";

export const reroute: Reroute = ({ url }) => {
	if (url.pathname.startsWith("/_app/immutable/")) return "/__immutable-archive";
	if (url.pathname === "/api/sentry") return url.pathname;
	if (url.pathname === "/api/health") return url.pathname;
	if (url.pathname === "/api/trpc" || url.pathname.startsWith("/api/trpc/")) return url.pathname;
	const domainEntry = getDomainEntry(url.hostname);
	if (domainEntry?.destination) {
		return `${domainEntry.destination}${url.pathname}`;
	}
	return url.pathname;
};
